import React, { PropsWithChildren } from 'react';
import { createContext, FC, useContext, useState } from 'react';

// Context.
interface MenuContextValue {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
}

const MenuContext = createContext<MenuContextValue>({
    isOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOpen: () => { }
});

export const useMenuContext = () => {
    return useContext(MenuContext);
};

// Provider.
export const MenuProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    // Render.
    return <MenuContext.Provider value={{ isOpen, setIsOpen }}>{children}</MenuContext.Provider>;
};

